import React from "react";
import CustomTable from "@sistemas.mundo/custom-table";
import useListSolicitudes from "../../../../queries/solicitudes/useListSolicitudes";

const TablaSolicitudes = () => {
  const tableRows = [
    { name: "id_solicitud", type: "", position: "left" },
    { name: "cont_nombres", type: "", position: "left", draw: (row) => row.tipo_solicitud.descripcion_tipo },
    { name: "fecha_creacion_formated", type: "", position: "left" },
    //{ name: "fecha_cierre_formated", type: "", position: "left" },
    { name: "cont_nombres", type: "", position: "left", draw: (row) => row.estado.descripcion_estado },
  ];

  const tableHeaders = [
    { name: "N° Solicitud", type: "", position: "left" },
    { name: "Motivo", type: "", position: "left" },
    { name: "Fecha de creación", type: "", position: "left" },
    //{ name: "Fecha de cierre", type: "", position: "left" },
    { name: "Estado", type: "", position: "left" },
    //{ name: "Respuesta", type: "", position: "left" },
  ];

  return <CustomTable queryData={useListSolicitudes} tableRows={tableRows} tableHeaders={tableHeaders} />;
};

export default TablaSolicitudes;
